import * as Styled from './MoreLikeThisButton.styled';

interface MoreLikeThisButtonProps {
  productName: string | null;
  productUrl: string | null;
}

// #2860: this button used to render only once the ShopBox SDK had been detected
// on `window`. That check ran per component instance, so tiles created later -
// notably the recycled nodes a carousel makes while scrolling - could resolve it
// differently from their neighbours, and the button appeared on some tiles and
// not others, breaking button alignment. The gate is gone: the button always
// renders when there is a product URL.
export const MoreLikeThisButton = ({ productName, productUrl }: MoreLikeThisButtonProps) => {
  if (!productUrl) return null;

  const absoluteUrl = productUrl.startsWith('http')
    ? productUrl
    : `${window.location.origin}${productUrl}`;

  return (
    <Styled.Button
      type="button"
      className="js-more-like-this"
      data-product-url={absoluteUrl}
      aria-label={`More like this – ${productName ?? 'this product'}`}
    >
      More like this
    </Styled.Button>
  );
};
